<template>
  <div class="c-led-strip" v-visible="!loading">
    <img class="background" :src="images.led_strip_r1" @load="onLoad" />
    <div class="leds">
      <div
        v-for="(color, index) in frameRGB"
        class="led"
        :class="{
          selected: (selectedIndexes || []).includes(index),
          disabled: isPlaying,
        }"
        :key="color + index"
        @mousedown.left="onMouseDownLeft({ color, index })"
        @mousedown.right="onMouseDownRight({ color, index })"
        @mouseenter="onMouseEnter({ color, index }, $event)"
        @contextmenu.prevent
      >
        <div class="content" :style="{ filter: `brightness(${brightness}0%)` }">
          <div class="background" :style="{ background: color }"></div>
          <div
            class="center"
            :style="{
              background: `radial-gradient(circle, ${color} 25%, transparent)`,
            }"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { speedList } from "@/utils";
export default {
  name: "CLedStrip",
  props: {
    isPlaying: Boolean,
    brightness: Number,
    speed: Number,
    frames: Array,
    frameIndex: Number,
    selectedIndexes: Array,
  },
  computed: {
    ...mapState("assets", {
      images: "images",
    }),
    ...mapState("profile", {
      version: "version",
    }),
    frameRGB() {
      if (this.frames) {
        const index = this.isPlaying ? this.playingIndex : this.frameIndex;
        return this.frames[index] ? this.frames[index].frameRGB : [];
      }
      return [];
    },
  },
  data() {
    return {
      loading: true,
      playingIndex: 0,
    };
  },
  watch: {
    isPlaying: function (isPlaying) {
      if (isPlaying) {
        this.play();
      }
    },
    speed() {
      this.play();
    },
  },
  methods: {
    play() {
      this.playingIndex = 0;
      clearTimeout(this.timer);
      if (this.isPlaying) {
        let speed = speedList[this.speed - 1];
        speed = speed > 100 ? 100 : speed;
        this.timer = setInterval(() => {
          this.playingIndex = this.playingIndex + 1;
          if (this.playingIndex >= this.frames.length) this.playingIndex = 0;
        }, speed - 2);
      }
    },
    onLoad() {
      this.loading = false;
    },
    onMouseDownLeft({ color, index }) {
      this.$emit("led-click", { color, index });
    },
    onMouseDownRight({ index }) {
      this.$emit("led-click-right", { index });
    },
    onMouseEnter({ color, index }, { which, buttons }) {
      if (buttons === undefined ? which === 1 : buttons === 1) {
        this.$emit("led-click", { color, index });
      } else if (buttons === undefined ? which === 3 : buttons === 2) {
        this.$emit("led-click-right", { index, solid: true });
      }
    },
  },
  mounted() {
    if (this.isPlaying) this.play();
  },
};
</script>

<style lang="scss" scoped>
.c-led-strip {
  width: 100%;
  position: relative;

  .background {
    width: 100%;
    height: auto;
    position: relative;
    -webkit-user-drag: none;
  }

  .leds {
    width: 91%;
    height: 86%;
    position: absolute;
    left: 4.5%;
    top: 7%;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    background: #2f3032;

    .led {
      width: 2.5%;
      height: 20%;
      padding: 0.15%;
      flex: none;
      cursor: pointer;

      &.selected,
      &:hover {
        background: $primary-color;
      }

      &.disabled {
        background: transparent;
        pointer-events: none;
        cursor: auto;
      }

      .content {
        width: 100%;
        height: 100%;
        border-radius: 20%;
        overflow: hidden;
        position: relative;

        .background {
          width: 100%;
          height: 100%;
          position: absolute;
          filter: brightness(60%);
        }

        .center {
          width: 100%;
          height: 100%;
          position: absolute;
          filter: brightness(110%);
        }
      }
    }
  }
}
</style>
